import { render, staticRenderFns } from "./HeaderOverlay.vue?vue&type=template&id=a1c32e18&scoped=true"
import script from "./HeaderOverlay.vue?vue&type=script&lang=js"
export * from "./HeaderOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c32e18",
  null
  
)

export default component.exports